import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // INFO - The menu bar is hidden by default. It only applies to tablet and
  // phone screen widths. For desktop and widescreen widths, the menu-bar is
  // always visible on the left side
  isMenuOpen: false,
};

const menuSlice = createSlice({
  name: 'menuBar',
  initialState,
  reducers: {
    toggleMenuOpen: (state) => {
      state.isMenuOpen = !state.isMenuOpen;
    },
  },
});

export const { toggleMenuOpen } = menuSlice.actions;
export default menuSlice.reducer;